// extracted by mini-css-extract-plugin
export default {"headerMenuProfile":"headerAuth-module__headerMenuProfile__qngCL","avatar":"headerAuth-module__avatar__rT1Yz","avatarCompact":"headerAuth-module__avatarCompact__NC3o9"};